import React from 'react';

import { useIntl } from 'react-intl';

import { ArrowLink } from 'components/arrow-link';
import { routes } from 'utils/routing';

const Account = () => {
  const { formatMessage } = useIntl();

  return (
    <ArrowLink data-testid="tims-rewards" to={routes.timsRewards}>
      {formatMessage({ id: 'thTimsRewards' })}
    </ArrowLink>
  );
};

export default Account;
